export default "__VITE_ASSET__BIziS3xb__"